import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import Styles from './styles.module.scss';

const ItemLoadingCard = () => {
    return (
        <div className={Styles.ItemCard}>
            <div className={Styles.ItemHeader}>
                <div className={Styles.CardPhoto}>
                    <Skeleton style={{ height: '100%', width: '100%' }} />
                </div>
                <div className={Styles.ItemDetails}>
                    <div className={Styles.CardName}>
                        <Skeleton />
                    </div>
                    <div className={Styles.CardCategory}>
                        <Skeleton />
                    </div>
                </div>
            </div>
            <div className={Styles.CardTotals}>
                <div className={Styles.CardTotal}>
                    <div style={{ textAlign: 'center', width: '100%' }} className={Styles.CardTotalTitle}>
                        <Skeleton style={{ width: '40%' }} />
                    </div>
                    <div style={{ textAlign: 'center' }} className={Styles.CardTotalValue}>
                        <Skeleton style={{ width: '90%' }} />
                    </div>
                </div>
                <div className={Styles.CardTotal}>
                    <div style={{ textAlign: 'center', width: '100%' }} className={Styles.CardTotalTitle}>
                        <Skeleton style={{ width: '40%' }} />
                    </div>
                    <div style={{ textAlign: 'center' }} className={Styles.CardTotalValue}>
                        <Skeleton style={{ width: '90%' }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemLoadingCard;
